

(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (App, View, Handler, Service, Controller, Config, Helper, Message, Model, $) {
    'use strict';

    Handler.flowHandler = function (flow, obj, status, xhr, options) {
        console.log('FlowHandler | ' + obj.code);
        switch (flow) {
            case 'A':
                if (!Model.ComboAccesoSuscripcion) {
                    Handler.flowA(obj, status, xhr, options);
                } else {
                    Handler.flowABis(obj, status, xhr, options);
                }
                break;
            case 'B':
                Handler.flowB(obj, status, xhr, options);
                break;
            case 'C':
                Handler.flowC(obj, status, xhr, options);
                break;
            case 'D':
                Handler.flowD(obj, status, xhr, options);
                break;
            case 'E':
                Handler.flowE(obj, status, xhr, options);
                break;
            case 'F':
                Handler.flowF(obj, status, xhr, options);
                break;
            //case 'G':
            //    Handler.flowG(obj, status, xhr);
            //    break;                              
            default:
                logger && logger.error('FlowHandler | No existe el tipo de error (' + flow + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");
        }
    }

    // ==================================================
    // Manejador de respustas ajax
    // ================================================== 
    Handler.flowA = function (obj, status, xhr, options) {
        console.log('FlowA | ' + obj.code);
        switch (obj.code) {
            case '07':
                View.tieneDeuda();
                break;
            case '08':
                // Es PP sin Deuda                
                if (Model.Window.combo == Config.PRODUCTO_PDF && !Helper.TieneProductoPremiumPDF()) {
                    View.pdfSuscriptoSinAcceso();
                } else {
                    Controller.yaTenia();
                }
                break;

            case '13': // Es Classic
            case '14': // No tiene credencial Activa
            case '04': // No esta asociado
            case '26': // No es black ni premium
                if (Model.Window.combo == Config.PRODUCTO_PDF) {
                    if (Helper.TieneAccesoDigital()) {
                        View.pdfSuscriptoSinAcceso();
                    } else {
                        View.pdfSinSuscripcion();
                    }
                } else {
                    View.wall()
                }
                break;
            case '25':
                // Es Premium Titular
                View.primerAcceso();
                break;
            case '28':
                // Es Black
                View.primerAcceso();
                break;
            case '30':
            case '31':
                View.wall();
                break;
            case '0001':
                logger && logger.fatal('FlowA | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            case '0005':
                logger && logger.error('FlowA | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FlowA | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");

        }
    }

    Handler.flowABis = function (obj, status, xhr, options) {
        console.log('FlowA Bis | ' + obj.code);
        switch (obj.code) {
            case '04':
            case '13':
            case '14':
            case '26':
            case '30':
            case '31':
                // No tiene producto premium.
                View.noTieneSuscripcion();
                break;
            case '07':
                View.tieneDeuda();
                break;
            case '08':
                // Es PP sin Deuda.
                Controller.yaTenia();
                break;

            case '25':
                // Es Premium Titular.
                View.primerAcceso();
                break;

            case '28':
                // Es Black.
                View.primerAcceso();
                break;
            case '0001':
                logger && logger.fatal('FlowA Bis | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FlowA Bis | No existe el codigo (' + obj.code + ') ', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");
        }
    }


    Handler.flowB = function (obj, status, xhr, options) {
        console.log('FlowB | ' + obj.code);
        switch (obj.code) {
            case '02':
                // No es producto premium
                // Ejecuto el controller inicio con el combo de la url
                Service.campanaObtener(Model.Window.landingCampaign || Config.campaniaPaga, function (res, status, xhr) {
                    Controller.inicio(Model.Cliente.comboElegido || Model.Window.combo);
                });
                break;
            case '07':
                View.tieneDeuda();
                break;
            case '08':
                // Es PP sin deuda
                //Helper.returnBack();
                Controller.yaCompro();
                break;
            case '0001':
                logger && logger.fatal('FlowB | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            case '0005':
                logger && logger.error('FlowB | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FlowB | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");
        }
    }

    Handler.flowC = function (obj, status, xhr, options) {
        console.log('FlowC | ' + obj.code);
        switch (obj.code) {
            case '04':
                // No esta asociado
                Controller.obtenerMontoACobrar(function () {
                    //View.ingresarDni();
                    if (!Model.Cliente.email) {
                        Model.Cliente.email = Helper.readCookie('usuarioemail');
                    }
                    View.formularioDatosPersonales();
                });
                break;
            case '07':
                // Tiene deuda
                View.tieneDeuda();
                break;
            case '13':
                // Es Classic
                Controller.obtenerMontoACobrar(function () {
                    Controller.obtenerDatosPersonales();
                });
                break;
            case '14':
                // No tiene Credenciales
                Controller.obtenerMontoACobrar(function () {
                    Controller.obtenerDatosPersonales();
                });
                break;
            case '21':
                Controller.yaCompro();
                break;
            case '25':// Es Premium Titular
            case '26':// Es Premium Adicional
            case '28':// Es Black
                View.yaTieneCuenta();
                break;
            case '30':
            case '31':
                Controller.obtenerMontoACobrar(function () {
                    Controller.obtenerDatosPersonales();
                });
                break;
            case '0001':
                logger && logger.fatal('FlowC | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            case '0005':
                logger && logger.error('FlowC | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FlowC | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");
        }
    }

    Handler.flowD = function (obj, status, xhr, options) {
        console.log('FlowD | ' + obj.code);
        switch (obj.code) {
            case '07':
                // Tiene deuda
                View.tieneDeuda();
                break;
            case '11':
                Model.Cliente.mailOfuscado = obj.message;
                Controller.ingresarDni_OtroUsuario();
                LN.AppEvent.sendEvent('DNI-ASOCIADO-A-OTRO');
                break;

            case '25':
            case '26':
            case '28':
                // Es black o premium activo
                // TODO : asociar credencial . 
                Handler.obtenerDatosClubHandler({ code: '2', response: [] })
                break;

            case '10':
            case '13':
            case '14':
            case '30':
            case '31':
                // Cliente nuevo: Compra
                //Controller.formularioDatosPersonalesClienteNuevo();
                Controller.formularioDatosPersonales();
                break;
            case '0001':
                logger && logger.fatal('FlowD | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            case '0005':
                logger && logger.error('FlowD | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FlowD | No existe el codigo  (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");
        }
    }

    Handler.flowE = function (obj, status, xhr, options) {
        console.log('FlowE | ' + obj.code);
        switch (obj.code) {
            case '07':
                // Tiene deuda
                View.tieneDeuda();
                break;
            case '13':
                // Es Classic activo
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                break;
            case '14':
                // No es Classic activo
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                break;
            case '25': // Es black o premium activo
            case '26': // Es Premium adicional
            case '28': // Es black o premium activo
                View.primerAcceso();
                break;
            case '30':
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                //View.mostrarMensajeUno();
                break;
            case '31':
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                //View.mostrarMensajeTribuno();
                break;
            case '0001':
                logger && logger.fatal('FlowE | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            case '0005':
                logger && logger.error('FlowE | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FlowE | No existe el codigo (' + obj.code + ')', { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");

        }
    }

    Handler.flowF = function (obj, status, xhr, options) {
        console.log('FlowF | ' + obj.code);
        switch (obj.code) {
            case '07':
                // Tiene deuda
                View.tieneDeuda();
                break;
            case '13':
                // Es Classic activo
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                break;
            case '14':
                // No es Classic activo
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                break;
            case '17':
            // Form corto . (dos ultimos numero de credencial)
            case '19':
            // Form corto . (credencial completa)
            case '20':
                // Form largo . 
                Controller.validarTipoAsociacionClub();
                break;
            case '21':
                Controller.yaCompro();
                break;
            case '25': // Premium
            case '26': // Es Premium adicional
            case '28': // Acepta TyC
                View.primerAcceso();
                break;
            case '30':
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                //View.mostrarMensajeUno();
                break;
            case '31':
                Helper.redirectToPaywall(Config.PLAN_INSUFICIENTE, Config.PRODUCTO_NOTA);
                //View.mostrarMensajeTribuno();
                break;
            case '0001':
                logger && logger.fatal('FlowF | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            case '0005':
                logger && logger.error('FlowF | ' + obj.message, { Response: obj, Model: Model });
                Service.mostrarError(Message.Error['GENERAL']);
                break;
            default:
                logger && logger.error('FlowF | No existe el codigo: ' + obj.code, { Response: obj, Model: Model });
                throw new Error("No existe el tipo de flow");

        }
    }
})(LN.App, LN.View, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/flowHandler.js